import React, { FC } from 'react';
import colors from '../../assets/colors';
import Styled from './styles';

type AppButtonProps = {
	image?: JSX.Element | null;
	imageLeft?: boolean;
	size?: 'small' | 'medium' | 'large';
	color?: keyof typeof colors;
	title?: string;
	variant?: 'contained' | 'text' | 'outlined';
	backgroundColor?: keyof typeof colors;
	borderColor?: keyof typeof colors;
	disabled?: boolean;
	isHover?: boolean;
	callBack?(): void;
};

const MUIButton: FC<AppButtonProps> = ({
	image = null,
	imageLeft = true,
	size = 'medium',
	color,
	title = 'Title',
	backgroundColor = 'black',
	borderColor = 'black',
	variant = 'contained',
	disabled = false,
	isHover = true,
	callBack = () => null,
}) => {
	return (
		<Styled.StyledButton
			onClick={callBack}
			variant={variant}
			size={size}
			sx={{
				color,
				backgroundColor,
				borderColor,
			}}
			disabled={disabled}
			isHover={isHover}
		>
			{imageLeft && image} {title} {!imageLeft && image}
		</Styled.StyledButton>
	);
};

export default MUIButton;
